<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i>Premade Categories</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-premade-category' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <premade-categories-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="premadeCategories" v-bind:actions="true"></premade-categories-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'
import PremadeCategoriesTable from "./Table";

export default {
  name: 'premade-categories-view',
  components: {PremadeCategoriesTable},
  data() {
        return {
            premadeCategories: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getPremadeCategories();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getPremadeCategories();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getPremadeCategories();
    },
    onPageChanged(page){
        this.page = page;        
        this.getPremadeCategories();
    },
    getPremadeCategories(){
        let  data = {
            page: this.page,
            q: this.q,
            orderBy:this.orderBy
        };
        this.premadeCategoryRepo.paginate(data).then(response => {
            this.premadeCategories = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-categories/View.vue